import { Lender, PricingRange } from '@nemuru-eng/js-api-client';

export const getLendersWithoutLenderEarningFees = (
  lenders: Lender[],
  lenderEarningFees: PricingRange['lenderEarningsFees'],
): Lender[] => {
  if (!lenderEarningFees) return lenders;
  const lenderIds = lenders.map((lender) => lender.id);
  return lenders.filter((lender) => {
    return !lenderEarningFees.some((earningFee) => {
      return earningFee.lenderId === lender.id && lenderIds.includes(lender.id);
    });
  });
};
